import { render, staticRenderFns } from "./seniorDismissalTab.vue?vue&type=template&id=742f8ec6"
import script from "./seniorDismissalTab.vue?vue&type=script&lang=js"
export * from "./seniorDismissalTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('742f8ec6')) {
      api.createRecord('742f8ec6', component.options)
    } else {
      api.reload('742f8ec6', component.options)
    }
    module.hot.accept("./seniorDismissalTab.vue?vue&type=template&id=742f8ec6", function () {
      api.rerender('742f8ec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/com/seniorDismissalTab.vue"
export default component.exports